module.exports = __webpack_public_path__ + "img/TBO-Website-Logo-768x682.b4566701.png";